"use client";

import { MapSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedMapSection from "../Components/GeneratedMapSection";

const Map: FC<MapSectionProps> = (props) => {
  return <GeneratedMapSection {...props} />;
};

export default Map;
